import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { RouteNames } from '../../route-names';

export const isNotAuthenticatedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isAuthenticated = inject(Store).selectSnapshot(AuthState.isAuthenticated);
  return !isAuthenticated || router.navigate([RouteNames.HOME]);
};
